// Add your custom JS here.


/* nav search overlay */

jQuery ( document ).ready ( function($) {
	
	$('#nav-search-close').click(function(){
		$('.nav-search').fadeOut();
		$('#main-menu').fadeIn();
	});
	
	$('.nav-item-search a').click(function(){
		event.preventDefault();
		$('.nav-search').fadeIn();
		$('#main-menu').fadeOut();
	});
	
});